<dx-toolbar class="cc-layout-toolbar header-property-container">
  <dxi-item
    itemTemplate="toolBarItemMenu"
    *ngIf="menuToggleEnabled"
    location="before"
  >
    <div *dxTemplate="let e of 'toolBarItemMenu'">
      <dx-button
        icon="menu"
        stylingMode="icon"
        hint="Hide Menu"
        class="cc-side-nav-menu-open header-menu-button"
        (onClick)="toggleMenu()"
        [ngClass]="{ 'header-menu-button-sm': isSmallScreen }"
      ></dx-button>
    </div>
  </dxi-item>

  <dxi-item [location]="logoLocation">
    <div *dxTemplate="let data of 'item'">
      <app-branding-image></app-branding-image>
    </div>
  </dxi-item>

  <dxi-item location="center">
    <div *dxTemplate class="cc-environment-container">
      <div
        *ngIf="!!currentEnvironment && !isXtraSmall"
        class="cc-marquee-container dx-theme-accent-as-text-color"
      >
        <div class="cc-marquee">
          <span *ngFor="let i of [].constructor(10)" class="cc-marquee-content">
            {{ currentEnvironment }}
          </span>
        </div>
      </div>
    </div>
  </dxi-item>

  <!-- Commenting cira chat component due to incorrect URL integration in V3  -->
  <!-- <dxi-item location="after" [visible]="false">
    <div *dxTemplate="let data of 'item'">
      <app-cira-chat></app-cira-chat>
    </div>
  </dxi-item> -->

  <dxi-item location="after">
    <div
      [ngClass]="{
        'announcement-button-content cc-announcement-button-content':
          announcementCount > 0,
        'announcement-disabled-button-content cc-announcement-grey-button-content':
          announcementCount === 0
      }"
      (click)="onAnnouncementClick()"
    >
      <app-icon
        name="speaker"
        size="40px"
        class="announcement-button"
        stroke="#121F38"
      ></app-icon>
      <div *ngIf="announcementCount > 0" class="badge-container">
        <div class="badger-inner-header">
          <p class="badger-badge-header">{{ announcementCount }}</p>
        </div>
      </div>
    </div>
  </dxi-item>

  <dxi-item location="after">
    <div *dxTemplate="let data of 'item'" class="user-button-container">
      <dx-button
        class="user-button authorization cc-dummy-button"
        [width]="menuButtonWidth"
        height="100%"
        stylingMode="text"
      >
        <div *dxTemplate="let data of 'content'">
          <app-user-panel
            [menuItems]="userMenuItems"
            menuMode="context"
          ></app-user-panel>
        </div>
      </dx-button>
    </div>
  </dxi-item>
  <div *dxTemplate="let data of 'menuItem'">
    <app-user-panel
      [menuItems]="userMenuItems"
      menuMode="list"
    ></app-user-panel>
  </div>
</dx-toolbar>

<app-preferences #preferenceComponent></app-preferences>
<app-change-password #changePasswordComponent></app-change-password>
<app-edit-profile #editProfileComponent></app-edit-profile>
<app-impersonate #impersonateComponent></app-impersonate>
<app-portal-announcement #announcementComponent></app-portal-announcement>

<app-default-property
  #defaultProperty
  [userProperties]="userProperties"
  (onSelection)="onDefaultSelection($event)"
></app-default-property>

<app-add-property-modal
  #addPropertyModal
  (onPropertyAdded)="onPropertyAdded()"
></app-add-property-modal>
